import { createFileRoute } from '@tanstack/react-router'

import { Redirecionar } from '@/components/layout/redirecionar'

export const Route = createFileRoute('/$perfil/times/')({
  component: SemTime,
})

/** `/<visão>/times` sem o time: a lista de times fica na Visão geral. */
function SemTime() {
  const { perfil } = Route.useParams()
  return <Redirecionar para={`/${perfil}/visao-geral`} />
}
